package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.ActiveTimer
import fr.manyverse.app.domain.repository.TimerRepository

class GetActiveTimersUseCase(private val timerRepository: TimerRepository) {
    suspend operator fun invoke(tableId: String): Result<List<ActiveTimer>> =
        timerRepository.getActiveTimers(tableId)
}
